import React from 'react';
import { withRouter, Route, Switch } from 'react-router';
import urlJoin from 'url-join';
import WebJobs from './DataLoads/WebJobs';
import DataDetails from './DataDetails/DataDetails';

import { getVirtualDirectory } from '../../common/helpermethods/HelperMethods';

export const PAGE_ROUTE = urlJoin(getVirtualDirectory(), '/summary/csadrilldown');
const detailsPath = urlJoin(getVirtualDirectory(), '/commodityReport/triggerJobs/details');
const normalPath = urlJoin(getVirtualDirectory(), '/commodityReport/triggerJobs');

export default (withRouter(() => (
    <Switch>
        <Route path={ detailsPath } component={ DataDetails } />
        <Route path={ normalPath } component={ WebJobs } />
        <Route component={ WebJobs } />
    </Switch>
)));
